<dashboardnav>
    <cradua-batch
    [batchs]="batchs$ | async"
    (batch)="onSubmitBatch($event)"
    (deleteBatchEvent)="onDeleteBatch($event)"
    *ngIf="(isLoadingBatch$ | async ) === false"
    >
  </cradua-batch>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingBatch$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>

